import { render, staticRenderFns } from "./s2Cell.vue?vue&type=template&id=ebb6ba8a&scoped=true&"
import script from "./s2Cell.vue?vue&type=script&lang=js&"
export * from "./s2Cell.vue?vue&type=script&lang=js&"
import style0 from "./s2Cell.vue?vue&type=style&index=0&id=ebb6ba8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebb6ba8a",
  null
  
)

export default component.exports